<template>
    <transition name="fade">

        <section>
            <div class="modal fade" id="modalPartCorp" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{doc.label}}</h5>
                        </div>
                        <div class="modal-body">


                            <!-- <div class="alert alert-danger" role="alert">
                                This is a danger alert with <a href="#" class="alert-link">an example link</a>. Give it a click if you like.
                            </div> -->

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Please upload the {{doc.label}}</label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref_partcorp" @change="$emit('attach', $event)">
                                            <input type="text" v-if="fetchATT[code] || formATT[code]" class="form-control form-control-sm ro" @click="browseRef()" readonly :value="doc.details['file']">
                                            <input type="text" v-else class="form-control form-control-sm ro" readonly value="Choose a file.." :class="{'is-invalid': submitting && $v.formATT[code].$error}" @click="browseRef()">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef()">
                                                    <span v-if="fetchATT[code] || formATT[code] ">Change</span>
                                                    <span v-else>Attach</span>
                                                </button>
                                                <button v-if="fetchATT[code] || formATT[code]" class="btn btn-sm btn-outline-primary ml-2" @click="viewATT(formATT[code], doc.label, fetchATT[code])">View</button>
                                            </div>
                                        </div>

                                        <div class="mt-1">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="progress" v-if="progress[code]">
                                                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress[code]+ ';'">
                                                            {{progress[code]}}
                                                        </div>
                                                    </div>
                                                    <span v-else class="badge" :class="doc.status">{{$parent.attStat(doc.status)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row">
                                <div class="col-12">
                                    <p class="bold">Please input the names of the beneficial owners based on the uploaded GIS/Articles of Partnership:</p>
                                    <div class="table-responsive tableFixHead mb-n2">
                                        <table class="table table-bordered table-sm fs-15">
                                            <thead>
                                                <tr>
                                                    <th>First Name</th>
                                                    <th>Middle Name</th>
                                                    <th>Last Name</th>
                                                    <th width="5%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for='(i, index) in beneficiary'>
                                                    <td>
                                                        <input v-model.trim="i.fname" class="form-control text-uppercase" @input="i.fname=$event.target.value.toUpperCase().trim()" type="text" :class="{'is-invalid':  $v.beneficiary.$each[index].fname.$error && submitting }" />
                                                    </td>
                                                    <td>
                                                        <input v-model.trim="i.mname" class="form-control text-uppercase" @input="i.mname=$event.target.value.toUpperCase().trim()" type="text" :class="{'is-invalid':  $v.beneficiary.$each[index].mname.$error && submitting }" />

                                                    </td>
                                                    <td>
                                                        <input v-model.trim="i.lname" class="form-control text-uppercase" @input="i.lname=$event.target.value.toUpperCase().trim()" type="text" :class="{'is-invalid':  $v.beneficiary.$each[index].lname.$error && submitting }" />

                                                    </td>
                                                    <td class="align-middle nowrap">
                                                        <button class="btn btn-sm btn-outline-primary" @click="addRow()">Add</button>
                                                        <button v-if="beneficiary.length > 1" class="btn btn-sm btn-outline-primary ml-1" @click="deleteRow(index)">Remove</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" data-dismiss="modal" @click="btnCancel">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="btnUpdate">Update</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalPartCorpATT" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{attachFile.title}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="col-12" v-if="attachFile.type=='img'">
                                <img :src="attachFile.url" class="img-fluid" alt="Image">
                            </div>
                            <div class="col-12" v-if="attachFile.type=='pdf'">
                                <object :data="attachFile.url + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="100%">
                                    <div class="alert alert-warning2" role="alert">
                                        <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                    </div>
                                </object>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" @click="closeModalPartCorp"><i class="fas fa-times-circle mr-1"></i>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan', 'docs', 'formATT', 'fetchATT', 'progress', 'attachFile'],
        data() {
            return {
                beneficiary: [{
                    fname: '',
                    mname: '',
                    lname: ''
                }],
                submitting: false,

                code: null,
                doc: []

            }
        },
        validations: {
            beneficiary: {
                $each: {
                    fname: {
                        required
                    },
                    mname: {
                        required
                    },
                    lname: {
                        required
                    },
                }
            },

            formATT: {
                ATT122: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT122 && this.code == 'ATT122';
                    })
                },
                ATT123: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT123 && this.code == 'ATT123';
                    })
                },
            }
        },
        created() {},
        methods: {
            addRow: function() {
                this.beneficiary.push({
                    fname: '',
                    mname: '',
                    lname: ''
                })
            },
            deleteRow(index) {
                this.beneficiary.splice(index, 1);
            },
            btnUpdate: _.debounce(function() {
                // if(this.beneficiary.length > 1)
                this.postPartCorp();
            }, 333),
            btnCancel() {

            },

            postPartCorp() {
                this.submitting = true;
                this.$v.formATT.$touch();
                this.$v.beneficiary.$touch();

                if (this.$v.formATT.$invalid || this.$v.beneficiary.$invalid) {


                } else {


                    let key = this.code;
                    this.$parent.$parent.payloading = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            if (this.formATT[key]) {
                                this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                            }
                        }.bind(this)
                    }
                    let formData = new FormData();
                    formData.append('borrower_id', this.formLoan.borrower_id);
                    formData.append('application_id', this.formLoan.application_id);
                    formData.append('upload_file', this.formATT[key]);
                    formData.append('attach_code', key);
                    formData.append('beneficiary', JSON.stringify(this.beneficiary));

                    axios.post('/api/v2-post-part-corp', formData, config)
                        .then(res => {
                            let data = res.data.attached;

                            if (data) {
                                this.formATT[key] = null;
                                this.progress[key] = 0;
                                this.doc.status = data.status;
                                this.doc.details['file'] = data.attach.slice(9);
                                this.formATT[key] = null;
                                this.fetchATT[key] = data.filepath + data.attach;
                            }
                            window.URL.revokeObjectURL(this.attachFile.url);
                            this.attachFile.url = null;
                            $('#modalPartCorp').modal('hide');

                            this.$parent.$parent.payloading = false;
                            Fire.$emit('getLoanReqATT');
                            Fire.$emit('getAttLoanReq');

                        }).catch(err => {
                            this.$parent.$parent.payloading = false;
                        })
                }
            },
            viewATT(formATT, title, fetchATT) {
                if (formATT) {
                    $('#modalPartCorp').modal('hide');
                    this.$parent.viewAttachFile(formATT, title, '#modalPartCorpATT');
                }
                if (fetchATT) {
                    $('#modalPartCorp').modal('hide');
                    this.$parent.viewFetch(fetchATT, title, '#modalPartCorpATT', 2)
                }
            },
            closeModalPartCorp() {
                window.URL.revokeObjectURL(this.attachFile.url);
                $('#modalPartCorpATT').modal('hide');
                for (let k in this.attachFile) {
                    this.attachFile[k] = null;
                }
                $('#modalPartCorp').modal('show');
            },
            downloadBusATT(fileURL, name) {
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', name.slice(name.length - 22));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            },
            browseRef() {
                document.getElementById('ref_partcorp').click();
            },

            getBeneficiary(code) {
                this.doc = this.docs.find(item => item.code === code);
                this.code = code;
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>